import React from 'react'

function Pagination({
  loadNextPage,
  loadPreviousPage,
  canLoadNext,
  canLoadPrevious
}) {
  return (
    <div className="flex justify-center md:justify-end mt-[32px] items-center gap-2">
      <nav className="relative z-0 pagination-count inline-flex flex-wrap items-center">
        {/* Previous Button */}
        <div className="flex items-center">
          <div
            className={`relative inline-flex justify-center items-center rounded-l-md p-2 text-sm cursor-pointer ${
              !canLoadPrevious
                ? 'text-gray-300 cursor-not-allowed'
                : 'text-gray-500 hover:bg-gray-200'
            }`}
            onClick={loadPreviousPage}
          >
            <svg
              className="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>

        {/* Next Button */}
        <div>
          <div
            className={`relative inline-flex items-center rounded-r-md p-2 text-sm cursor-pointer ${
              !canLoadNext
                ? 'text-gray-300 cursor-not-allowed'
                : 'text-gray-500 hover:bg-gray-200'
            }`}
            onClick={loadNextPage}
          >
            <svg
              className="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Pagination;
